import { render, staticRenderFns } from "./outbound-fax-missed-icon.vue?vue&type=template&id=71e294ae"
import script from "./outbound-fax-missed-icon.vue?vue&type=script&lang=js"
export * from "./outbound-fax-missed-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports